import React, { useEffect, useState } from "react";
import { getCookie } from "@/helpers/cookies";
import { useTimer } from "@/app/hooks/useTimer";

const LeaderboardChristmasBadge = (props: any) => {
  const { isPlacedInMenu = false, IsRAFEnabled } = props;
  const isAuth = getCookie("BotB.Authenticated");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNewYear, setIsNewYear] = useState(false);

  const targetDate = new Date("2025-12-31T23:59:59");
  const targetDateChristmasDraws = new Date("2026-01-08T23:59:59");
  const targetDateRAF = new Date("2026-01-31T23:59:59");
  const timezoneOffset = new Date().getTimezoneOffset() * 60000;

  const englandTargetDate = new Date(targetDate.getTime() - timezoneOffset);
  const englandTargetDateChristmasDraws = new Date(targetDateChristmasDraws.getTime() - timezoneOffset);
  const englandTargetDateRAF = new Date(targetDateRAF.getTime() - timezoneOffset);
  const now = new Date();

  const isLeaderboardActive = englandTargetDate.getTime() - now.getTime() > 0; // > 0 Leaderboard is active
  const isRAFActive = englandTargetDateRAF.getTime() - now.getTime() > 0; // > 0 RAF is active

  const leaderboardClick = () => {
    if (location.pathname === "/christmas-leaderboard") {
      return setIsDropdownOpen(false);
    }
    return (location.href = "/christmas-leaderboard");
  };
  const raffleClick = () => {
    if (location.pathname === "/big-7-draws") {
      return setIsDropdownOpen(false);
    }
    return (location.href = "/big-7-draws");
  };

  const referAFriendClick = () => {
    if (location.pathname === "/refer-a-friend") {
      return setIsDropdownOpen(false);
    }
    return (location.href = "/refer-a-friend");
  };

  useEffect(() => {
    // from 2 January is new logo with black.
    if (location.pathname === "/refer-a-friend") {
      setIsNewYear(true);
    }
  }, []);

  const timer = useTimer("headerTimer", englandTargetDateRAF.getTime(), undefined, "millisecond");
  if (!isRAFActive) {
    return null;
  }
  return (
    <>
      {isNewYear ? (
        <>
          <div
            className={
              "rounded-[6.4px] lg:rounded-[9.6px] w-[107px] lg:w-[174px] h-[35px] lg:h-12 bg-gradient-to-br from-black to-[#4D4D4D] skew-x-[-8deg]"
            }>
            <div className={"text-center py-1 lg:pt-[4.5px]"}>
              <div
                className={
                  "text-white uppercase tracking-[-0.5px] lg:tracking-[-0.7px] antialiased [text-shadow:_0px_0px_4px_rgb(255_130_0_/_0.30)] lg:[text-shadow:_0px_0px_4px_rgb(255_130_0_/_0.30)] text-[10px] lg:text-sm font-black"
                }>
                Ends in
              </div>
              <div
                className={
                  "text-yellow-3 flex-center text-[10.40px] lg:text-base antialiased font-black leading-3 lg:leading-[12.8px] [text-shadow:_0px_0px_3px_rgb(255_130_0_/_0.50)] lg:[text-shadow:_0px_0px_3px_rgb(255_130_0_/_0.50)]"
                }>
                {timer.isPastADay ? (
                  <div>
                    {timer.days !== "01" && timer.days} {timer.days === "01" ? "TOMORROW" : "DAYS"}
                  </div>
                ) : (
                  <div className={"flex gap-1"}>
                    <div>{timer.hours}h</div>
                    <div>:</div>
                    <div>{timer.minutes}m</div>
                    <div>:</div>
                    <div>
                      <span>{timer.seconds}</span>
                      <span>
                        {Math.floor(timer.milliseconds / 10)
                          .toString()
                          .padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {isPlacedInMenu ? (
            <div>
              <div className="text-gray-1 mb-3 font-jost text-xs font-medium leading-4 lg:text-sm lg:leading-5">
                DECEMBER CAMPAIGN
              </div>
              <div className={"relative font-jost z-40"}>
                {/*badge*/}
                <div
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className={
                    "rounded-lg relative z-[1] cursor-pointer h-[68px] min-w-32 flex items-center lg:min-w-[184px] pr-[7px] shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.20)]"
                  }>
                  <img
                    src={"/assets/images/leaderboard/light_menu.png"}
                    width={343}
                    height={68}
                    alt={"light"}
                    className={"absolute inset-0 object-cover min-w-full h-full rounded-lg z-0"}
                  />
                  <div className={"h-[68px] min-w-[84px] overflow-hidden relative"}>
                    <img
                      src={"/assets/images/leaderboard/bell.png"}
                      width={112}
                      height={112}
                      alt={"bell"}
                      className={"absolute -left-[4px] -top-3 size-[82px] rotate-[9.502deg] lg:rotate-[10.333deg]"}
                    />
                  </div>
                  <div className={"flex items-center gap-2 h-full justify-between relative z-10"}>
                    <div className={"flex flex-col justify-center"}>
                      <div className={"text-white text-[15px] lg:text-base leading-6 lg:tracking-tighter font-bold"}>
                        A December to Remember
                      </div>
                      <div
                        className={
                          "text-xs font-medium leading-3.5 bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                        }>
                        £700,000 reasons to remember this December
                      </div>
                    </div>
                    <div className={"bg-black/15 rounded-full size-6 min-w-6 flex-center"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        className={`size-4 lg:size-5 transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}>
                        <path
                          d="M12 6L8 10L4 6"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                {/*pop-up*/}
                {/*absolute top-[calc(100%-8px)] right-0 w-full lg:w-[340px] rounded-b-lg py-6 px-4 bg-[radial-gradient(ellipse_123.52%_461.70%_at_102.63%_95.31%,_#B3080A_0%,_#7F0203_49%,_#5F0103_100%)] shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.20)]"}*/}
                {isDropdownOpen && (
                  <div
                    className={
                      "w-full -mt-2 lg:w-[340px] rounded-b-lg py-6 px-4 bg-[radial-gradient(ellipse_123.52%_461.70%_at_102.63%_95.31%,_#B3080A_0%,_#7F0203_49%,_#5F0103_100%)] shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.20)]"
                    }>
                    {/*rows*/}
                    <div className={"w-full"}>
                      {isLeaderboardActive ? (
                        <div
                          onClick={leaderboardClick}
                          className={
                            "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 cursor-pointer bg-gradient-to-r from-[#D15000]/0 to-[#9A2525]"
                          }>
                          <div className={"size-11 lg:size-[52px] flex-center"}>
                            <img
                              src={"/assets/images/leaderboard/gift-1.png"}
                              alt={"The £200,000 Christmas Leaderboard"}
                              className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                            />
                          </div>
                          <div
                            className={
                              "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                            }>
                            The{" "}
                            <span
                              className={
                                "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                              }>
                              £200,000
                            </span>{" "}
                            Christmas Leaderboard
                          </div>
                          <div className={"ml-auto lg:ml-7.5"}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className={"size-6"}>
                              <rect
                                x="1.04907e-06"
                                y="24"
                                width="24"
                                height="24"
                                rx="12"
                                transform="rotate(-90 1.04907e-06 24)"
                                fill="black"
                                fill-opacity="0.15"
                              />
                              <path
                                d="M10 16L14 12L10 8"
                                stroke="white"
                                stroke-opacity="0.6"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={
                            "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 overflow-hidden relative pointer-events-none"
                          }>
                          <div className={"size-11 lg:size-[52px] flex-center"}>
                            <img
                              src={"/assets/images/leaderboard/gift-1.png"}
                              alt={"The £200,000 Christmas Leaderboard"}
                              className={"w-full h-auto min-w-11 lg:min-w-[52px] grayscale"}
                            />
                          </div>
                          {/*REMOVE - opacity-40*/}
                          <div
                            className={
                              "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px] opacity-40"
                            }>
                            The{" "}
                            <span
                              className={
                                "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                              }>
                              £200,000
                            </span>{" "}
                            Christmas Leaderboard
                          </div>
                          {/*REMOVE  - invisible*/}
                          <div className={"ml-auto lg:ml-7.5 invisible"}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className={"size-6"}>
                              <rect
                                x="1.04907e-06"
                                y="24"
                                width="24"
                                height="24"
                                rx="12"
                                transform="rotate(-90 1.04907e-06 24)"
                                fill="black"
                                fill-opacity="0.15"
                              />
                              <path
                                d="M10 16L14 12L10 8"
                                stroke="white"
                                stroke-opacity="0.6"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                      <div
                        onClick={raffleClick}
                        className={
                          "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 overflow-hidden relative bg-gradient-to-r from-[#D15000]/0 to-[#9A2525] cursor-pointer"
                        }>
                        <div className={"size-11 lg:size-[52px] flex-center"}>
                          <img
                            src={"/assets/images/leaderboard/gift-2.png"}
                            alt={"The £400,000 Christmas Draws"}
                            className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                          />
                        </div>
                        <div
                          className={
                            "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                          }>
                          The{" "}
                          <span
                            className={
                              "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                            }>
                            £400,000
                          </span>{" "}
                          Christmas Draws
                        </div>
                        <div className={"ml-auto lg:ml-7.5"}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className={"size-6"}>
                            <rect
                              x="1.04907e-06"
                              y="24"
                              width="24"
                              height="24"
                              rx="12"
                              transform="rotate(-90 1.04907e-06 24)"
                              fill="black"
                              fill-opacity="0.15"
                            />
                            <path
                              d="M10 16L14 12L10 8"
                              stroke="white"
                              stroke-opacity="0.6"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      {isRAFActive && (
                        <>
                          {IsRAFEnabled && isAuth === "true" ? (
                            <div
                              onClick={referAFriendClick}
                              className={
                                "flex items-center rounded-lg border border-white/12 pl-1.5 pr-2 py-1.5 overflow-hidden relative bg-gradient-to-r from-[#D15000]/0 to-[#9A2525] cursor-pointer"
                              }>
                              <div className={"size-11 lg:size-[52px] flex-center"}>
                                <img
                                  src={"/assets/images/leaderboard/gift-3.png"}
                                  alt={"The £100,000 Refer a Friend draw"}
                                  className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                                />
                              </div>
                              {/*REMOVE - opacity-40*/}
                              <div
                                className={
                                  "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                                }>
                                The{" "}
                                <span
                                  className={
                                    "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                                  }>
                                  £100,000
                                </span>{" "}
                                Refer a Friend draw
                              </div>
                              {/*REMOVE  - invisible*/}
                              <div className={"ml-auto lg:ml-7.5"}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  className={"size-6"}>
                                  <rect
                                    x="1.04907e-06"
                                    y="24"
                                    width="24"
                                    height="24"
                                    rx="12"
                                    transform="rotate(-90 1.04907e-06 24)"
                                    fill="black"
                                    fill-opacity="0.15"
                                  />
                                  <path
                                    d="M10 16L14 12L10 8"
                                    stroke="white"
                                    stroke-opacity="0.6"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                          ) : (
                            <div
                              className={
                                "flex items-center rounded-lg border border-white/12 pl-1.5 pr-2 py-1.5 overflow-hidden relative pointer-events-none"
                              }>
                              <div className={"size-11 lg:size-[52px] flex-center"}>
                                <img
                                  src={"/assets/images/leaderboard/gift-3.png"}
                                  alt={"The £100,000 Refer a Friend draw"}
                                  className={"w-full h-auto min-w-11 lg:min-w-[52px] grayscale"}
                                />
                              </div>
                              {/*REMOVE - opacity-40*/}
                              <div
                                className={
                                  "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px] opacity-40"
                                }>
                                The{" "}
                                <span
                                  className={
                                    "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                                  }>
                                  £100,000
                                </span>{" "}
                                Refer a Friend draw
                              </div>
                              {/*REMOVE  - invisible*/}
                              <div className={"ml-auto lg:ml-7.5 invisible"}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  className={"size-6"}>
                                  <rect
                                    x="1.04907e-06"
                                    y="24"
                                    width="24"
                                    height="24"
                                    rx="12"
                                    transform="rotate(-90 1.04907e-06 24)"
                                    fill="black"
                                    fill-opacity="0.15"
                                  />
                                  <path
                                    d="M10 16L14 12L10 8"
                                    stroke="white"
                                    stroke-opacity="0.6"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                              {/*disabled badge*/}
                              <div className={"flex-center absolute right-0 bottom-0"}>
                                <img
                                  src={"/assets/images/leaderboard/pattern-disabled-users.png"}
                                  width={178}
                                  height={31}
                                  alt={"bell"}
                                  className={"h-6.5 lg:h-[25px] w-auto rotate-[-2.46deg]"}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className={"relative font-jost"}>
              {/*badge*/}
              <div
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className={
                  "rounded-lg cursor-pointer h-9 lg:h-12 min-w-32 lg:min-w-[184px] pr-[7px] bg-[radial-gradient(ellipse_123.52%_461.70%_at_102.63%_95.31%,_#B3080A_0%,_#7F0203_49%,_#5F0103_100%)] shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.20)]"
                }>
                <div className={"absolute z-20 left-0 -translate-x-1/2 top-1/2 -translate-y-1/2"}>
                  <img
                    src={"/assets/images/leaderboard/bell.png"}
                    width={112}
                    height={112}
                    alt={"bell"}
                    className={"size-14 lg:size-[72px] rotate-[9.502deg] lg:rotate-[10.333deg]"}
                  />
                </div>
                <div className={"flex items-center gap-2 h-full"}>
                  <div className={"pl-7 lg:pl-9 flex flex-col justify-center gap-0.5 lg:gap-1.5"}>
                    <div
                      className={
                        "text-white uppercase text-[10px] lg:text-sm font-bold leading-[11px] lg:leading-none"
                      }>
                      A December to
                    </div>
                    <div
                      className={
                        "text-[13px] lg:text-[17px] italic uppercase font-bold leading-[11px] lg:leading-none bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                      }>
                      Remember
                    </div>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className={`size-4 lg:size-5 transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}>
                      <path
                        d="M12 6L8 10L4 6"
                        stroke="white"
                        stroke-opacity="0.6"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              {/*pop-up*/}
              {isDropdownOpen && (
                <div
                  className={
                    "absolute top-[calc(100%+8px)] right-0 w-[300px] lg:w-[340px] rounded-lg pt-6 pb-5 px-3 bg-[radial-gradient(ellipse_123.52%_461.70%_at_102.63%_95.31%,_#B3080A_0%,_#7F0203_49%,_#5F0103_100%)] shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.20)]"
                  }>
                  {/*title*/}
                  <div
                    className={
                      "text-center text-white font-medium text-lg lg:text-xl leading-6 lg:leading-6.5 mb-5 lg:mb-4"
                    }>
                    <span
                      className={
                        "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                      }>
                      £700,000 Reasons
                    </span>
                    <br />
                    to remember this December
                  </div>
                  {/*rows*/}
                  <div className={"w-full"}>
                    {isLeaderboardActive ? (
                      <div
                        onClick={leaderboardClick}
                        className={
                          "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 cursor-pointer bg-gradient-to-r from-[#D15000]/0 to-[#9A2525]"
                        }>
                        <div className={"size-11 lg:size-[52px] flex-center"}>
                          <img
                            src={"/assets/images/leaderboard/gift-1.png"}
                            alt={"The £200,000 Christmas Leaderboard"}
                            className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                          />
                        </div>
                        <div
                          className={
                            "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                          }>
                          The{" "}
                          <span
                            className={
                              "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                            }>
                            £200,000
                          </span>{" "}
                          Christmas Leaderboard
                        </div>
                        <div className={"ml-3 lg:ml-7.5"}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className={"size-6"}>
                            <rect
                              x="1.04907e-06"
                              y="24"
                              width="24"
                              height="24"
                              rx="12"
                              transform="rotate(-90 1.04907e-06 24)"
                              fill="black"
                              fill-opacity="0.15"
                            />
                            <path
                              d="M10 16L14 12L10 8"
                              stroke="white"
                              stroke-opacity="0.6"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    ) : (
                      <div
                        className={
                          "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 overflow-hidden relative pointer-events-none"
                        }>
                        <div className={"size-11 lg:size-[52px] flex-center"}>
                          <img
                            src={"/assets/images/leaderboard/gift-1.png"}
                            alt={"The £200,000 Christmas Leaderboard"}
                            className={"w-full h-auto min-w-11 lg:min-w-[52px] grayscale"}
                          />
                        </div>
                        {/*REMOVE - opacity-40*/}
                        <div
                          className={
                            "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px] opacity-40"
                          }>
                          The{" "}
                          <span
                            className={
                              "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                            }>
                            £200,000
                          </span>{" "}
                          Christmas Leaderboard
                        </div>
                        {/*REMOVE  - invisible*/}
                        <div className={"ml-3 lg:ml-7.5 invisible"}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className={"size-6"}>
                            <rect
                              x="1.04907e-06"
                              y="24"
                              width="24"
                              height="24"
                              rx="12"
                              transform="rotate(-90 1.04907e-06 24)"
                              fill="black"
                              fill-opacity="0.15"
                            />
                            <path
                              d="M10 16L14 12L10 8"
                              stroke="white"
                              stroke-opacity="0.6"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                    <div
                      onClick={raffleClick}
                      className={
                        "flex items-center rounded-lg border border-white/12 mb-3 pl-1.5 pr-2 py-1.5 overflow-hidden relative bg-gradient-to-r from-[#D15000]/0 to-[#9A2525] cursor-pointer"
                      }>
                      <div className={"size-11 lg:size-[52px] flex-center"}>
                        <img
                          src={"/assets/images/leaderboard/gift-2.png"}
                          alt={"The £400,000 Christmas Draws"}
                          className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                        />
                      </div>
                      <div
                        className={
                          "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                        }>
                        The{" "}
                        <span
                          className={
                            "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                          }>
                          £400,000
                        </span>{" "}
                        Christmas Draws
                      </div>
                      <div className={"ml-3 lg:ml-7.5"}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className={"size-6"}>
                          <rect
                            x="1.04907e-06"
                            y="24"
                            width="24"
                            height="24"
                            rx="12"
                            transform="rotate(-90 1.04907e-06 24)"
                            fill="black"
                            fill-opacity="0.15"
                          />
                          <path
                            d="M10 16L14 12L10 8"
                            stroke="white"
                            stroke-opacity="0.6"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    {isRAFActive && (
                      <>
                        {IsRAFEnabled && isAuth === "true" ? (
                          <div
                            onClick={referAFriendClick}
                            className={
                              "flex items-center rounded-lg border border-white/12 pl-1.5 pr-2 py-1.5 overflow-hidden relative bg-gradient-to-r from-[#D15000]/0 to-[#9A2525] cursor-pointer"
                            }>
                            <div className={"size-11 lg:size-[52px] flex-center"}>
                              <img
                                src={"/assets/images/leaderboard/gift-3.png"}
                                alt={"The £100,000 Refer a Friend draw"}
                                className={"w-full h-auto min-w-11 lg:min-w-[52px]"}
                              />
                            </div>
                            {/*REMOVE - opacity-40*/}
                            <div
                              className={
                                "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px]"
                              }>
                              The{" "}
                              <span
                                className={
                                  "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                                }>
                                £100,000
                              </span>{" "}
                              Refer a Friend draw
                            </div>
                            {/*REMOVE  - invisible*/}
                            <div className={"ml-3 lg:ml-7.5"}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className={"size-6"}>
                                <rect
                                  x="1.04907e-06"
                                  y="24"
                                  width="24"
                                  height="24"
                                  rx="12"
                                  transform="rotate(-90 1.04907e-06 24)"
                                  fill="black"
                                  fill-opacity="0.15"
                                />
                                <path
                                  d="M10 16L14 12L10 8"
                                  stroke="white"
                                  stroke-opacity="0.6"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              "flex items-center rounded-lg border border-white/12 pl-1.5 pr-2 py-1.5 overflow-hidden relative pointer-events-none"
                            }>
                            <div className={"size-11 lg:size-[52px] flex-center"}>
                              <img
                                src={"/assets/images/leaderboard/gift-3.png"}
                                alt={"The £100,000 Refer a Friend draw"}
                                className={"w-full h-auto min-w-11 lg:min-w-[52px] grayscale"}
                              />
                            </div>
                            {/*REMOVE - opacity-40*/}
                            <div
                              className={
                                "text-white ml-3 text-[13px] lg:text-base leading-4.5 lg:leading-5.5 font-medium lg:max-w-[168px] opacity-40"
                              }>
                              The{" "}
                              <span
                                className={
                                  "font-bold bg-gradient-to-br from-[#E3C187] to-[#FBEDC8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                                }>
                                £100,000
                              </span>{" "}
                              Refer a Friend draw
                            </div>
                            {/*REMOVE  - invisible*/}
                            <div className={"ml-3 lg:ml-7.5 invisible"}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className={"size-6"}>
                                <rect
                                  x="1.04907e-06"
                                  y="24"
                                  width="24"
                                  height="24"
                                  rx="12"
                                  transform="rotate(-90 1.04907e-06 24)"
                                  fill="black"
                                  fill-opacity="0.15"
                                />
                                <path
                                  d="M10 16L14 12L10 8"
                                  stroke="white"
                                  stroke-opacity="0.6"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            {/*disabled badge*/}
                            <div className={"flex-center absolute right-0 bottom-0"}>
                              <img
                                src={"/assets/images/leaderboard/pattern-disabled-users.png"}
                                width={178}
                                height={31}
                                alt={"bell"}
                                className={"h-6.5 lg:h-[25px] w-auto rotate-[-2.46deg]"}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default LeaderboardChristmasBadge;
